<template>
  <div>
    <div class="bj dis-cent">
      <div class="contentBody">
        <div class="iconfont icon-close dis-cent" @click="del"></div>
        <div
          class="content scroll"
          ref="content"
          id="contentBox"
          style="font-family: Arial, sans-serif"
        >
          <div class="headCont">
            <div class="img">
              <img
                :src="
                  info.member_info.avatars != '/static/avatar/man.png'
                    ? $imgUrl + info.member_info.avatars
                    : info.member_info.sex_cn == '男'
                    ? 'https://www.yhrl.com/static/avatar/man.png'
                    : 'https://www.yhrl.com/static/avatar/woman.png'
                "
                alt=""
              />
            </div>
            <div class="cont">
              <div class="titleBox">
                <div class="box">
                  <div class="name">
                    {{ daysNum > 0 ? info.member_info.realname : "" }}
                    {{ " NO." + info.member_info.member_id }}
                    {{ info.member_info.avatars }}
                  </div>
                  <div
                    class="iconfont icon-nan1 nan"
                    v-if="info.member_info.sex_cn == '男'"
                  ></div>
                  <div
                    class="iconfont icon-nv nv"
                    v-if="info.member_info.sex_cn == '女'"
                  ></div>
                  <div class="text">{{ timeTxt }}</div>
                  <div class="txt" v-if="age != 2024">{{ age }}岁</div>
                  <div class="txt" v-if="age == 2024">未填写</div>
                  <div class="shu"></div>
                  <div class="txt">{{ info.member_info.experience_cn }}</div>
                  <div class="shu"></div>
                  <div class="txt">{{ info.member_info.education_cn }}</div>
                  <div class="shu" v-if="daysNum > 0"></div>
                  <div class="txt" v-if="daysNum > 0">
                    {{ info.member_info.phone }}
                  </div>
                </div>
              </div>
              <div class="contTxt">
                <div
                  class="txt"
                  v-html="'求职状态：' + info.member_info.current_cn"
                ></div>
              </div>
              <div class="contTxt">
                <div
                  class="txt"
                  v-html="
                    info.member_info.speciality
                      ? info.member_info.speciality
                      : '暂无信息'
                  "
                ></div>
              </div>
            </div>
          </div>
          <div class="wzCont" v-if="info.remarks.id">
            <div class="title">我的评价</div>
            <div class="cont">
              <div class="textBox">
                {{
                  info.remarks.remarks
                    ? info.remarks.remarks
                    : "该人才未填写此内容"
                }}
              </div>
            </div>
          </div>
          <div class="wzCont">
            <div class="title">工作经验</div>
            <div class="cont">
              <div class="textBox">
                {{
                  info.member_info.domain
                    ? info.member_info.domain
                    : "该人才未填写此内容"
                }}
              </div>
            </div>
          </div>
          <div class="wzCont" v-if="info.member_job">
            <div class="title">期望职位</div>
            <div class="cont">
              <div class="textBox" v-for="item in info.member_job">
                <div class="box">
                  <div class="text">{{ item.intention_jobs }}</div>
                  <div class="shu"></div>
                  <div class="text">{{ item.district_cn }}</div>
                  <div class="shu"></div>
                  <div class="text">{{ item.trade_cn }}</div>
                  <div class="shu"></div>
                  <div class="text">
                    {{
                      item.minprice == 0 && item.maxprice == 0
                        ? "面议"
                        : item.minprice + "-" + item.maxprice + "K"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wzCont" v-if="info.member_experience">
            <div class="title">工作经历</div>
            <div class="cont">
              <div class="conts" v-for="item in info.member_experience">
                <div class="textBox">
                  <div class="box">
                    <div class="text">{{ item.companyname }}</div>
                    <div class="shu1"></div>
                    <div class="text">{{ item.jobs }}</div>
                  </div>
                  <div class="time" v-if="item.start_time">
                    {{ item.start_time }} - {{ item.end_time }}
                  </div>
                  <div class="time" v-else>
                    {{ item.startyear }}.{{ item.startmonth }} -
                    {{ item.endyear }}.{{ item.endmonth }}
                  </div>
                </div>
                <div class="contTxt">
                  <div class="name">工作内容：</div>
                  <div class="text" v-html="item.achievements"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="wzCont" v-if="info.member_education">
            <div class="title">教育经历</div>
            <div class="cont">
              <div class="jyBoxs">
                <div class="jyBox" v-for="item in info.member_education">
                  <!-- <div class="img">
                    <img
                      src=""
                      alt=""
                    />
                  </div> -->
                  <div class="jyBoxCont">
                    <div class="textBox">
                      <div class="box">
                        <div class="text">{{ item.school }}</div>
                        <div class="shu"></div>
                        <div class="text">{{ item.speciality }}</div>
                        <div class="shu"></div>
                        <div class="text">{{ item.education_cn }}</div>
                      </div>
                      <div class="time" v-if="item.start_time">
                        {{ item.start_time }} - {{ item.end_time }}
                      </div>
                      <div class="time" v-else>
                        {{ item.startyear }}.{{ item.startmonth }} -
                        {{ item.endyear }}.{{ item.endmonth }}
                      </div>
                    </div>
                    <div class="txt" v-if="item.content">
                      {{ item.content }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="wzCont" v-if="info.member_certificate">
            <div class="title">荣誉证书</div>
            <div class="cont">
              <div class="ryBoxs">
                <div class="ryBox" v-for="item in info.member_certificate">
                  <div class="img" v-if="item.resource">
                    <img :src="$imgUrl + item.resource" alt="" />
                  </div>
                  <div class="ryBoxCont">
                    <div class="textBox">
                      <div class="box">
                        <div class="text">{{ item.name }}</div>
                      </div>
                    </div>
                    <div class="txt">{{ item.start_time }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dibuBtm"></div>
        </div>
        <!-- <div class="youbian">
          <div class="img">
            <img src="../../assets/img/change.png" alt="" />
            <div class="icon dis-cent">
              <div class="iconfont icon-enter"></div>
            </div>
          </div>
        </div>
        <div class="zuo">
          <div class="img">
            <img src="../../assets/img/change.png" alt="" />
            <div class="icon dis-cent">
              <div class="iconfont icon-return"></div>
            </div>
          </div>
        </div> -->
        <div class="dibuBtn">
          <div
            class="csBox"
            :class="info.is_favorite ? 'on' : ''"
            @click="scClick"
          >
            <div
              class="iconfont"
              :class="
                info.is_favorite ? 'icon-collection_fill' : 'icon-collection'
              "
            ></div>
            <div class="txt">收藏</div>
          </div>
          <div class="dis-cent">
            <div class="btn dis-cent" @click="exportAsPDF">导出简历</div>
            <div
              class="btn dis-cent"
              v-if="info.member_info.resource"
              @click="fjClick"
            >
              查看简历附件
            </div>
            <div
              class="btn dis-cent"
              @click="exportAsImage"
              v-if="this.type != 1"
            >
              在线沟通
            </div>
            <div class="btn dis-cent" @click.stop="dpClick">点评</div>
            <div class="btn dis-cent hong" @click.stop="ycClick">屏蔽</div>
          </div>
        </div>
      </div>
    </div>
    <JobList :member_id="id" v-if="jobShow" @show="jobShowJs" />
    <Dianping v-if="dianpingShow" @show="dpDelClick" :id="peoId" />
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import JobList from "./jobList.vue";
import Dianping from "./dianping.vue";
export default {
  components: {
    JobList,
    Dianping,
  },
  name: "",
  data() {
    return {
      jobShow: false,
      info: {
        member_info: {},
        member_certificate: [],
        member_education: [],
        member_experience: [],
        member_job: [],
        member_setmeal: {},
        remarks: {},
      },
      timeTxt: "",
      age: "",
      daysNum: 0,
      dianpingShow: false,
    };
  },
  props: ["id", "type"],
  watch: {},
  created() {
    console.log(this.type);
    if (this.id) {
      this.get();
    }
    this.vipGet();
  },
  methods: {
    dpClick() {
      this.peoId = this.id;
      this.dianpingShow = true;
    },
    ycClick() {
      let data = {
        member_id: this.id,
      };
      data = JSON.stringify(data);
      this.$post("/nozzle/web/company_block_save", {
        data,
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.info.is_favorite = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    dpDelClick(id) {
      this.dianpingShow = false;
      this.get();
    },
    vipGet() {
      this.$get("/nozzle/web/company_vip").then((res) => {
        console.log(res);
        let startDate = this.$moment().format();
        let dateTimeStamp = this.$moment(res.vip.endtime * 1000).format();
        dateTimeStamp = this.$moment(dateTimeStamp);
        this.daysNum = dateTimeStamp.diff(startDate, "days");
      });
    },
    scClick() {
      this.$post("/nozzle/web/favorite_save", {
        id: this.id,
        genre: 3,
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.info.is_favorite = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    get() {
      this.$get("/nozzle/web/member_get", {
        id: this.id,
      }).then((res) => {
        console.log(res.data);
        this.info = res.data;
        const currentYear = new Date().getFullYear();
        this.age = currentYear - Number(res.data.member_info.birthday);
        this.timeTxt = this.timeago(res.data.member_info.last_login_time);
      });
    },
    timeago(dateTimeStamp) {
      let minute = 1000 * 60;
      let hour = minute * 60;
      let day = hour * 24;
      let week = day * 7;
      let month = day * 30;
      let time1 = new Date().getTime(); //当前的时间戳
      dateTimeStamp = this.$moment(dateTimeStamp * 1000).format();
      dateTimeStamp = this.$moment(dateTimeStamp).format("YYYY/M/D HH:mm");
      let time2 = Date.parse(new Date(dateTimeStamp)); //指定时间的时间戳
      let time = time1 - time2;
      let result = null;
      if (time < 0) {
        result = "--";
      } else if (time / month >= 1) {
        result = parseInt(time / month) + "月前";
      } else if (time / week >= 1) {
        result = parseInt(time / week) + "周前";
      } else if (time / day >= 1) {
        result = parseInt(time / day) + "天前";
      } else if (time / hour >= 1) {
        result = parseInt(time / hour) + "小时前";
      } else if (time / minute >= 1) {
        result = parseInt(time / minute) + "分钟前";
      } else {
        result = "刚刚";
      }
      return result;
    },
    exportPDF() {
      const element = document.getElementById("pdf-content");
      const options = {
        margin: 1,
        filename: "example.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, logging: true }, // 使用 scale 来提高清晰度
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      html2pdf().set(options).from(element).save();
    },
    fjClick() {
      console.log(this.$imgUrl + this.info.member_info.resource);
      if (this.info.member_info.resource) {
        window.open(this.$imgUrl + this.info.member_info.resource);
        this.$message.success("导出成功");
      }
    },
    exportAsPDF() {
      this.$get("/nozzle/web/member_download", {
        id: this.id,
      }).then((res) => {
        console.log(res);
        // res = JSON.parse(res)
        if (res.status == 1) {
          const element = document.getElementById("contentBox"); // 替换为目标元素的id或class
          const totalHeight = element.scrollHeight;
          html2canvas(element, {
            scale: 2, // 提高分辨率
            useCORS: true, // 处理跨域图片
            allowTaint: true, // 允许跨域内容
            height: totalHeight,
            windowHeight: totalHeight,
          }).then((canvas) => {
            const image = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = pdfWidth;
            const imgHeight = (canvas.height * pdfWidth) / canvas.width;

            let position = 0;

            if (imgHeight <= pdfHeight) {
              pdf.addImage(image, "PNG", 0, 0, imgWidth, imgHeight);
            } else {
              while (position < imgHeight) {
                pdf.addImage(image, "PNG", 0, -position, imgWidth, imgHeight);
                position += pdfHeight;
                if (position < imgHeight) {
                  pdf.addPage();
                }
              }
            }

            pdf.save("document.pdf");
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    jobShowJs() {
      this.jobShow = false;
    },
    exportAsImage() {
      this.jobShow = true;
      // this.$post("/chat/chat_begin", {
      //   id: this.id,
      //   user_type: 2,
      // }).then((res) => {
      //   // console.log(res);
      //   if (res.data.status == 1) {
      //     this.$router.push({
      //       path: "/gongsi/message",
      //       query: {
      //         id: this.id,
      //       },
      //     });
      //   } else {
      //     this.$message.error(res.data.msg);
      //   }
      // });
    },
    del() {
      this.$emit("show");
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.contentBody {
  width: 798px;
  height: 98vh;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  overflow: hidden;

  .icon-close {
    width: 28px;
    height: 28px;
    border-radius: 3px;
    background-color: #ebebeb;
    position: absolute;
    top: 13px;
    right: 13px;
    color: #bebebe;
    cursor: pointer;
    z-index: 8;
  }

  .youbian {
    width: 50px;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 2;

    .img {
      position: relative;
      cursor: pointer;

      img {
        width: 25px;
        opacity: 0.2;
      }

      .icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        color: #9c9c9c;
        height: 100%;
      }
    }
  }

  .zuo {
    width: 50px;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    display: flex;
    align-items: center;
    z-index: 5;

    .img {
      position: relative;
      cursor: pointer;

      img {
        width: 25px;
        opacity: 0.2;
        transform: rotate(180deg);
      }

      .icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        color: #9c9c9c;
        height: 100%;
      }
    }
  }
}

.content {
  height: 100%;
  padding: 50px 50px 90px;
  box-sizing: border-box;
  position: relative;
  overflow: auto;
  color: #606677;
  font-family: Arial, sans-serif;

  .headCont {
    display: flex;

    .img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }

    .cont {
      width: calc(100% - 60px);
      padding-left: 20px;
      box-sizing: border-box;

      .titleBox {
        display: flex;
        font-size: 12px;
        align-items: center;
        justify-content: space-between;

        .box {
          display: flex;
          align-items: center;

          .name {
            font-size: 18px;
          }

          .nan {
            color: #168ae9;
            margin: 0 10px;
            position: relative;
            top: 1px;
          }

          .nv {
            color: #e916bb;
            margin: 0 10px;
            position: relative;
            top: 1px;
          }

          .text {
            color: #333;
            margin-right: 10px;
          }

          .shu {
            margin: 0 12px;
            width: 1px;
            height: 12px;
            background-color: #ebebeb;
          }
        }
      }

      .contTxt {
        line-height: 150%;
        margin-top: 5px;
        color: #606677;

        // .txt {
        //   margin-bottom: 5px;
        // }
      }
    }
  }

  .wzCont {
    display: flex;
    margin-top: 15px;
    background-color: #ebf7ff;
    padding: 15px;
    border-radius: 10px;

    .title {
      width: 60px;
      color: rgba(0, 0, 0, 0.8);
      font-weight: 600;
    }

    .cont {
      width: calc(100% - 60px);
      padding-left: 20px;

      .conts {
        margin-bottom: 20px;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 20px;
      }

      .conts:last-child {
        padding-bottom: 0;
        border-bottom: none;
      }

      .textBox {
        display: flex;
        align-items: center;
        // color: #606677;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .box {
          display: flex;

          .text {
            max-width: 200px;
          }

          .shu {
            margin: 0 15px;
            width: 1px;
            height: 12px;
            background-color: #ebebeb;
          }

          .shu1 {
            margin: 0 20px;
            width: 1px;
            height: 12px;
            background-color: #ebebeb;
          }
        }

        .time {
          font-size: 12px;
          color: #9c9c9c;
        }
      }

      .textBox:last-child {
        margin-bottom: 0;
      }

      .contTxt {
        margin-top: 15px;
        color: #606677;

        .text {
          line-height: 150%;
          margin-top: 7px;
        }
      }

      .conts:last-child {
        margin-bottom: 0;
      }

      .jyBoxs {
        border-bottom: 1px solid #ebebeb;

        .jyBox {
          display: flex;
          margin-bottom: 20px;

          .img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
          }

          .jyBoxCont {
            padding-left: 15px;
            width: calc(100% - 1px);
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            .txt {
              font-size: 12px;
              color: #606677;
              margin-top: 5px;
            }
          }
        }
      }

      .ryBoxs {
        border-bottom: 1px solid #ebebeb;

        .ryBox {
          display: flex;
          margin-bottom: 20px;

          .img {
            // width: 220px;
            height: 150px;
            border-radius: 5px;
            margin-right: 15px;

            img {
              // object-fit: cover;
              // height: auto;
              width: auto;
            }
          }

          .ryBoxCont {
            width: calc(100% - 235px);
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            .text {
              font-size: 16px;
            }

            .txt {
              font-size: 14px;
              color: #606677;
            }
          }
        }
      }
    }
  }

  .dibuBtm {
    position: absolute;
  }
}

.csBox {
  display: flex;
  align-items: center;
  color: #b4b4b4;
  cursor: pointer;
  font-size: 16px;

  .iconfont {
    position: relative;
    font-size: 26px;
    margin-right: 3px;
  }
}

.csBox:hover {
  color: #e41313;
}

.on {
  color: #e41313;
}

.dibuBtn {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 70px;
  background-color: #fff;
  z-index: 9;
  box-shadow: 0 0 8px 4px #ebebeb;
  display: flex;
  // justify-content: flex-end;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;

  .btn {
    margin-left: 15px;
    background-color: #168ae9;
    color: #fff;
    border-radius: 5px;
    width: 120px;
    height: 40px;
    cursor: pointer;
  }

  .btn:first-child {
    background-color: #0cb4b4;
  }
  .hong {
    background-color: #df0f0f;
  }
}
</style>
